<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东进公司受邀参加黄江镇校园食品安全管理工作会议</h2>
        <div id="meta_content">
          <span class="rich_a">
            毕磊
          </span>
          <span class="rich_b">
            东进防控
          </span>
          <span id="rich_c">
            <span>2024-03-08 08:42</span>
            广东
          </span>
        </div>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <p>
          为切实抓好校园食品安全管理，保障校园师生的身体健康，3月7日下午，黄江镇食安办召开全镇校园食品安全管理工作会议，黄江镇城管分局、黄江镇市场监管分局、黄江镇教育管理中心分管领导出席会议并发言。黄江镇各级各类学校分管领导、食品安全员和校外供餐单位食品安全员参加会议。
        </p>
        <img
          width="100%"
          :src="img[1]"
          alt=""
        >
        <p>
          东进公司受邀在黄江镇第一小学报告厅进行一场关于校园食堂“四害”防治专题讲座。公司特地邀请了病媒生物防控行业的专家丁祥翔就食堂后厨、食材仓库、用餐环境等区域，详细阐述了病媒生物防治的技术要点及标准要求，分享了如何预防和控制病媒生物的传播经验，阐述了校园加强病媒生物防控的重要性和迫切性，提升各级各类学校和供校集体用餐配送单位有害生物防制能力。
        </p>
        <p>
          食品安全牵动着广大黄江人民群众的心，东进公司作为当前全国唯一一家病媒生物防控的市属国企，将义不容辞承担起应有的社会责任，助力黄江各所教育机构切实做好病媒生物防控，筑牢食品安全防线。形成校园食品安全风险管控闭环，全力守护黄江镇师生“舌尖上的安全”。
        </p>
        <h3>我们还提供多元化服务</h3><img
          width="100%"
          :src="img[3]"
          alt=""
        >
        <h3>扫码关注我们了解更多</h3>
        <!-- <div class="big-div">
          <div class="small-div1">
            <img :src="img[4]" alt="">
            <div class="caption">时代东进 砥砺奋进</div>
          </div>
          <div class="small-div2">
            <img :src="img[5]" alt="">
            <div class="caption">www.tonking.com.cn <br>0769-22008298</div>
          </div>
        </div> -->
        <div>
          <img
            :src="img[4]"
            alt=""
          >
        </div>

      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News11' })"
          >东进公司道滘镇病媒生物...&nbsp;&nbsp;&nbsp;&nbsp;上一条 &gt;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News9' })"
          >东进公司受邀参加黄江镇...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news10-1.png'), require('@/assets/news10-2.png'), require('@/assets/news10-3.png'), require('@/assets/news8-4.png'), require('@/assets/news8-7.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-bottom: 22px;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
